import {HttpClient} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {catchError, Observable, throwError} from 'rxjs';
import {environment} from '../../environments/environment';
import {Cai} from '../models/Cai';

@Injectable({
  providedIn: 'root'
})
export class CaiService {

  private readonly url = environment.caiUrl;

  constructor(private readonly httpClient: HttpClient) { }

  public getAllCai(): Observable<Cai[]> {
    return this.httpClient.get<Cai[]>(this.url);
  }

  public addUpdate(cai: Cai, add: boolean): Observable<Cai> {
    if (add) {
      return this.add(cai);
    } else {
      return this.update(cai);
    }
  }

  public add(cai: Cai): Observable<Cai> {
    return this.httpClient.post<Cai>(this.url , cai).pipe(
      catchError((err) => {
        console.log("Saving failed for cai: " + cai.nroCai);
        return throwError(err);
      })
    );
  }

  public update(cai: Cai): Observable<Cai> {
    return this.httpClient.put<Cai>(this.url , cai).pipe(
      catchError((err) => {
        console.log("Saving failed for cai: " + cai.nroCai);
        return throwError(err);
      })
    );
  }
}
